import { Factory } from "../Factory";

export class ResourceWrapperService {
  // wrap given actions of a resource — auth is handled by AuthInterceptor
  public WrapActions(resource) {
    let wrappedResource = resource;
    let actions = ["get", "save", "query", "remove", "delete", "update", "run", "cancel", "status"];

    actions.forEach((action) => {
      let proxy_action = resource[action];
      resource[action] = (params, data, success, error) => {
        return proxy_action.call(this, params, data, success, error);
      };
    });

    return wrappedResource;
  }
}

frontendApp.factory("ResourceWrapperService", [
  Factory.Create(ResourceWrapperService),
]);
